import React from 'react';
import { Link } from 'react-router-dom';
import './ScrollStackSection.css';

const ScrollStackSection: React.FC = () => {
  const services = [
    {
      id: 'civil-law',
      title: 'Civil Law Service',
      description: 'Our service gives information on a civil law attorney practice in Coimbatore including money handling cases, property disputes, enforcement of contracts, partitions, injunction suits, eviction suits, claims for accidents, succession matters, real estate matters, and building disputes. Our service gives information on why a skilled civil attorney matters, how to hire a civil attorney, civil law FAQs, and civil law attorney FAQs.',
    },
    {
      id: 'property-law',
      title: 'Property Law Service',
      description: 'Our property law practice portfolio comprises purchase/sale transaction, due diligence, registration, title & boundary disputes, landlord & tenant matters, real estate development schemes, property tax, and real estate financing in Coimbatore. Furthermore, this highlights the importance of an attorney with a monopoly in property law, and descriptions of important documenting work include lease, transfer, title, and tenancy agreements.',
    },
    {
      id: 'consumer-law',
      title: 'Consumer Law Service',
      description: 'The main focus of our law practice is dealing with consumer rights with respect to product liability, defective products, consumer fraud, trade practices, contracts and warranties, debt harassment, and insurance. Our firm’s consumer law services outlines complaints, notices and agreement drafting and why you would need to choose a consumer lawyer and ask related FAQs.',
    },
    {
      id: 'arbitration-law',
      title: 'Arbitration Law Service',
      description: 'An alternative dispute resolution method and positions the firm as a leading arbitration practice in Coimbatore. Our services include  drafting arbitration clauses/agreements while representing parties in arbitral proceedings, ADR support, contract drafting and negotiation and enforcing arbitral awards plus guidance on choosing an arbitration lawyer and learning more about arbitration scope and benefits.',
    },
    {
      id: 'criminal-law',
      title: 'Criminal law service',
      description: 'Advocate Kannan’s criminal defense service details for individuals facing charges such as cybercrime, white-collar offences, violent crimes, assault and harassment. We provide services like legal advice, bail and anticipatory bail, trail and appeal representation, drafting complaints and petitions. We craft your reasons to hire a top criminal lawyer with the selection criteria and faqs covering role and types of cases handled.',
    },
    {
      id: 'debt-recovery-tribunal',
      title: 'Debt Recovery Tribunal Service',
      description: 'This service describes the specialised representation before the debt recovery tribunal for banks and financial institutions seeking recovery of bad debts and NPAs. It lists services such as drafting notices to defaulters, filing DTR applications, evidence preparation and conducting DRT proceedings and appeals. Through enforcing DRT orders via execution we also explain why a DRT specialist is needed.',
    },
    {
      id: 'chit-fund',
      title: 'Chit Fund Cases Service',
      description: 'Chit fund disputes arise from chit fund schemes including fraud, mismanagement, non-payment and fund distribution conflicts. Our firm offers you consultations, court representation, drafting notices, agreements, trust deeds and related documents, due diligence and compliance advice. Our services highlight reasons to hire a chit-fund specialist and factors for choosing one.',
    },
    {
      id: 'banking-law',
      title: 'Banking Law Service',
      description: 'Our banking law service outlines supporting banks and financial-sectors clients with compliance, documentation, transactions and disputes. Our services include drafting a wide range of banking documents like loan and security documents, guarantees, mortgages, indemnities, LC and BG papers and restructuring and debt -recovery notices with regulatory compliance with RBI rules while handling disputes and diligence.',
    },
    {
      id: 'electricity-law',
      title: 'Electricity law service',
      description: 'Our electricity lawyers will assist you by navigating complex regulatory frameworks while developing compliance strategies and negotiating contracts related to electricity. We also represent clients in litigations, arbitrations and other dispute resolution proceedings that are related to electricity. You can obtain knowledgeable legal counsel at Advocate Kannan for electricity related disputes and issues.',
    },
  ];

  return (
    <section className="scroll-stack-section">
      <div className="services-grid-container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-description">{service.description}</p>
              <Link to={`/services/${service.id}`} className="service-card-link">
                Read More <span className="link-arrow">»</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScrollStackSection;
